import { createFileRoute } from '@tanstack/react-router';
import { Button } from 'ht-sdk/react';
import { useForm } from 'react-hook-form';
import { SetLocationSchema, type SetLocation } from '@shared/modelTypes/location-types';
import { Form, resolver, TextField } from 'ht-sdk/react/forms';
import { loadLocationState } from '@/engine/actions';
import { useEffect, useState } from 'react';
import { useDeviceId } from '@/engine/store';

export const Route = createFileRoute('/set-location')({
	component: RouteComponent,
});

function RouteComponent() {
	// const setLocation = useStore((s) => s.setLocation);
	// const router = useRouter();

	// const onSubmit = async (data: SetLocation) => {
	// 	loadLocationState(data)
	// 	// const res = await api.getLocationByCode(data);
	// 	// if (!res.success) {
	// 	// 	// TODO: consider some other way to handle this
	// 	// 	toast.error(res.message);
	// 	// 	return;
	// 	// }

	// 	// setLocation(res.data);

	// 	// router.navigate({ to: '/set-player' });
	// };
	return <CodeForm onSubmit={loadLocationState} />;
}

function CodeForm({ onSubmit }: { onSubmit: (data: SetLocation) => void }) {
	const deviceId = useDeviceId();

	const [active, setActive] = useState(false);
	const methods = useForm({
		resolver: resolver(SetLocationSchema),
		defaultValues: { deviceId },
	});

	useEffect(() => {
		const id = requestAnimationFrame(() => setActive(true));
		return () => cancelAnimationFrame(id);
	}, []);

	return (
		<section className={`flex h-screen w-screen flex-col items-center justify-center gap-4 overflow-hidden`}>
			<Ticket
				className={`fixed top-1/2 left-1/2 ${active ? '-translate-1/2' : '-translate-x-1/2 translate-y-[120vh]'} flex min-h-86 flex-col justify-between overflow-hidden transition-transform duration-300 ease-out`}
			>
				<div>
					<p className="responsive-text-2xl">Welkom!</p>
					<p className="responsive-text-lg text-purple-200">Voer je evenementcode in om in te checken.</p>
				</div>
				<hr className="absolute top-1/2 left-1/2 w-full -translate-x-1/2 -translate-y-1/2 border-0 border-b-8 border-dashed border-purple-400/50" />
				<div className="w-[90%]">
					<Form methods={methods} onSubmit={onSubmit}>
						<TextField name="deviceId" type="hidden" label={null} autoFocus={true} autoComplete="off" />
						<TextField
							name="code"
							label={null}
							autoFocus={true}
							autoComplete="off"
							placeholder={`Enter event code`}
							className="uppercase placeholder:normal-case"
						/>
						<Button type="submit" className="relative mt-2">
							{`Check in!`}
						</Button>
					</Form>
				</div>
			</Ticket>
		</section>
	);
}

function Ticket({ children, className }: { children?: React.ReactNode; className?: string }) {
	return (
		<div
			className={`aspect-[1.1] h-[40%] rounded-[20px] bg-purple-400/30 p-4 [--r:40px] [mask:radial-gradient(var(--r)_at_var(--r),#0000_calc(100%),#000)_calc(-1*var(--r))] ${className}`}
		>
			{children}
		</div>
	);
}
